module.exports = __webpack_public_path__ + "img/bg1.166d4fc9.png";